<template>
  <div id="printStock" class="printStock" style="font-size: 15px;padding: 30px;">
    <div class="row-me center-all title" style="margin-top: 20px;">
      <span style="font-size: 25px;">库存单据</span>
    </div>
    <div class="row-me row-center flex-sb margin-top30" style="margin-top: 20px;">
      <div>单据批号：{{ detailItem.batchNo }}</div>
      <div>单据类型：{{ title }}&emsp;{{ detailItem.typeName }}</div>
      <div>目的仓库：{{ detailItem.pharmacyName }}</div>
    </div>
    <div class="table-print-border" style="margin-top: 20px;">
      <div class="row-me">
        <div class="item-cell">药品名称</div>
        <div class="item-cell">规格</div>
        <div class="item-cell">单位</div>
        <div class="item-cell">批号</div>
        <div class="item-cell">有效期</div>
        <div class="item-cell">申请数量</div>
        <div class="item-cell">成本价</div>
        <div class="item-cell">总价</div>
        <div class="item-cell">生产日期</div>
        <div class="item-cell">生产商</div>
        <div class="item-cell">产地</div>
        <div class="item-cell">库存数量</div>
      </div>
      <div class="row-me" v-for="(item,index) in detailItem.details" :key="index">
        <div class="item-cell">{{ item.drugName }}</div>
        <div class="item-cell">{{ item.spec }}</div>
        <div class="item-cell">{{ item.unitName }}</div>
        <div class="item-cell">{{ item.batchNo }}</div>
        <div class="item-cell">{{ item.validityTime }}</div>
        <div class="item-cell">{{ item.nums }}</div>
        <div class="item-cell">{{ item.costPrice }}</div>
        <div class="item-cell">{{ item.totalPrice }}</div>
        <div class="item-cell">{{ item.produceTime }}</div>
        <div class="item-cell">{{ item.producerName }}</div>
        <div class="item-cell">{{ item.productAddress }}</div>
        <div class="item-cell">{{ item.avaNums }}</div>
      </div>
    </div>
    <div class="row-me row-center flex-end1 margin-top30" style="margin-top: 20px;">
      <div>合计金额：{{ detailItem.totalPrice }}</div>
      <div class="margin-left50">执行人：{{ detailItem.updateBy }}</div>
      <div class="margin-left50">执行日期：{{ detailItem.updateTime }}</div>
    </div>
    <button v-show="false" id="btn" v-print="'#printStock'"></button>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    id: {
      type: Number,
      default: -1,
    },
    title: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      detailItem: {}
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {

  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    getDetail() {
      let url = ''
      if (this.title === '入库单') {
        url = '/admin/stock/getInStorage/'
      } else if (this.title === '出库单') {
        url = '/admin/stock/getOutStorage/'
      }
      this.$getRequest(url + this.id, {}).then((res) => {
        if (res) {
          this.detailItem = res.data
          this.$nextTick(() => {
            this.startPrint()
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    startPrint() {
      document.getElementById("btn").click();
    },
  },
}
</script>

<style lang="scss" scoped>
/*去除页眉页脚*/
@page {
  size: auto;
  /* auto is the initial value */
  margin: 3mm;
  /* this affects the margin in the printer settings */
}

html {
  background-color: #FFFFFF;
  margin: 0;
  /* this affects the margin on the html before sending to printer */
}

body {
  border: solid 1px blue;
  margin: 10mm 15mm 10mm 15mm;
  /* margin you want for the content */
}

.printStock {
  font-size: 18px;
  padding: 10px;

  .title {
    font-size: 30px !important;
    font-weight: bold;
    margin-top: 20px;
  }

  .table-print-border {
    border-left: 1px solid #000000;
    border-top: 1px solid #000000;
    margin-top: 30px;

    .item-cell {
      flex: 1;
      padding: 10px 0;
      border-right: 1px solid #000000;
      border-bottom: 1px solid #000000;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      word-break: break-all;
    }
  }
}
</style>
